import React from 'react';
import { useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import withObjectBrowser from '@plone/volto/components/manage/Sidebar/ObjectBrowser';

import { mpfServicosCatalogoSchema } from './schema';

const Data = (props) => {
  const { block, data, onChangeBlock } = props;
  const intl = useIntl();
  const schema = mpfServicosCatalogoSchema({ intl });

  return (
    <BlockDataForm
      {...props}
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) =>
        onChangeBlock(block, { ...data, [id]: value })
      }
      onChangeBlock={onChangeBlock}
      formData={data}
      block={block}
    />
  );
};

export default withObjectBrowser(Data);
